




































import Vue, { PropType } from 'vue'
import Dialog from '@/components/Dialog.vue'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import RemittanceDetails from './RemittanceDetails.vue'
import History from '../../History.vue'
import ExtraInfo from './ExtraInfo.vue'

export default Vue.extend({
  components: {
    appDialog: Dialog,
    appRemittanceDetails: RemittanceDetails,
    appHistory: History,
    appExtraInfo: ExtraInfo,
  },
  props: {
    item: Object as PropType<Remittance>,
  },
  data() {
    return {
      tabs: 0,
    }
  },
})
